
const locale = {
    VehicleVIOReport: "Køretøj VIO-rapport",
    ArticleVIOReport: "Artikel VIO-rapport",
    History: "Historie",
    UserManagement: "Brugerstyring"
}

export default locale;